import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  HStack,
  IconButton,
  Select,
  Table,
  TableCaption,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { MdOutlineSaveAlt } from "react-icons/md";
import { ModalAddParceirosContatos } from "./ModalAddParceirosContatos";

export const ModalContatos = (dados) => {

  return (
    <Box mt="1rem" w="100%">
      <Center>
        <HStack mt="1rem">
          {!dados.visualizar ? 
            <ModalAddParceirosContatos data={dados.data.data} insertNewContact={dados.insertNewContact}/> :
            <></>
          }
          
          {/* <Button
            size="sm"
            w="6rem"
            bgColor="#ff9045"
            leftIcon={<MdOutlineSaveAlt color="white" size="25px" />}
            ml="1.5rem"
            color="white"
            _hover={{ opacity: 0.8 }}
            boxShadow="none !important"
          >
            Salvar
          </Button> */}
        </HStack>
      </Center>
      <Center>
        <Box w="1320px" mt="1rem" fontFamily="Akrobat">
          <Table mt="1rem" variant="striped" colorScheme="blackAlpha">
            <TableCaption fontFamily="Akrobat ExtraBold">
              Tabela de Contatos
            </TableCaption>
            <Thead>
              <Box>
                <Tr>
                  {!dados.visualizar ? 
                    <Th w="190px" color="#03a9f4">
                      Editar
                    </Th> :
                    <></>
                  }
                  
                  <Th w="190px" color="#03a9f4">
                    Nome do Contato
                  </Th>
                  <Th w="150px" color="#03a9f4">
                    Telefone
                  </Th>
                  <Th w="150px" color="#03a9f4">
                    Ramal
                  </Th>

                  <Th w="200px" color="#03a9f4">
                    Celular
                  </Th>
                  <Th w="170px" color="#03a9f4">
                    E-mail
                  </Th>
                  <Th w="150px" color="#03a9f4">
                    Depto
                  </Th>

                  <Th w="170px" color="#03a9f4">
                    Origem
                  </Th>
                  {!dados.visualizar ? 
                    <Th color="#03a9f4">Excluir</Th> :
                    <></>
                  }
                </Tr>
              </Box>
            </Thead>
            <Tbody>
              <Box w="1320px" overflowY="scroll" maxH="280px">
                {dados.data.data.contatos.map((dado) => {
                  return (
                    <Tr>
                      
                      {!dados.visualizar ? 
                        <Td w="190px">
                          <ModalAddParceirosContatos data={dados.data.data} contact={dado} insertNewContact={dados.insertNewContact}/>
                        </Td> :
                        <></>
                      }
                      <Td w="190px">
                        {dado.nome_contato === null || dado.nome_contato === ""
                          ? "Sem Informação"
                          : dado.nome_contato}
                      </Td>
                      <Td w="150px">
                        {dado.telefone_contato === null ||
                        dado.telefone_contato === ""
                          ? "Sem Informação"
                          : dado.telefone_contato}
                      </Td>
                      <Td w="150px">
                        {dado.ramal_contato === null ||
                        dado.ramal_contato === ""
                          ? "Sem Informação"
                          : dado.ramal_contato}
                      </Td>
                      <Td w="150px">
                        {dado.celular_contato === null ||
                        dado.celular_contato === ""
                          ? "Sem Informação"
                          : dado.celular_contato}
                      </Td>
                      <Td w="150px">
                        {dado.email_contato === null ||
                        dado.email_contato === ""
                          ? "Sem Informação"
                          : dado.email_contato}
                      </Td>
                      <Td w="150px">
                        {dado.departamento_contato === null ||
                        dado.departamento_contato === ""
                          ? "Sem Informação"
                          : dado.departamento_contato}
                      </Td>
                      <Td w="150px">
                        <Select
                          cursor="pointer"
                          variant="unstyled"
                          iconColor="#03a9f4"
                          w="150px"
                        >
                          <option>
                            {dado.origem_contato === null ||
                            dado.origem_contato === ""
                              ? "Sem Informação"
                              : dado.origem_contato}
                          </option>
                        </Select>
                      </Td>
                      {!dados.visualizar ? 
                        <Td>
                          <IconButton
                            colorScheme="whiteAlpha"
                            leftIcon={<DeleteIcon color="#03a9f4" size="25px"
                            onClick={()=> dados.deleteContact({"codigo_parceiro":dados.data.data.codigo_parceiro,"codigo_contato":dado.codigo_contato})}/>}
                          />
                        </Td> : <></>
                      }
                      
                    </Tr>
                  );
                })}
              </Box>
            </Tbody>
          </Table>
        </Box>
      </Center>
    </Box>
  );
};
